<template>
  <main-template hide-franquia>
    <v-container class="px-4 py-6" fluid>
      <!-- Header Section -->
      <v-row align="center" class="mb-6">
        <v-col cols="12" class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-3 elevation-1 bg-white"
            @click="$router.push({ name: 'acessoResponsavel.home' })"
            aria-label="Voltar"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div>
            <h1 class="text-h5 font-weight-bold primary--text mb-1">Frequência Notifiq</h1>
            <p class="text-subtitle-2 text--secondary mb-0">
              Histórico de acessos de entrada e saída do aluno.
            </p>
          </div>
        </v-col>
      </v-row>

      <!-- Stats Section -->
      <v-row class="mb-6">
        <v-col cols="6" sm="6" md="3">
          <v-card class="elevation-2 rounded-lg border-left-success" outlined>
            <v-card-text class="d-flex align-center py-4 px-3">
              <v-avatar color="green lighten-5" size="48" class="mr-3">
                <v-icon color="green">mdi-login</v-icon>
              </v-avatar>
              <div>
                <span class="d-block text-caption font-weight-medium text-uppercase text--secondary"
                  >Entradas</span
                >
                <span class="text-h5 font-weight-bold green--text">{{ totalEntradas }}</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" sm="6" md="3">
          <v-card class="elevation-2 rounded-lg border-left-warning" outlined>
            <v-card-text class="d-flex align-center py-4 px-3">
              <v-avatar color="orange lighten-5" size="48" class="mr-3">
                <v-icon color="orange">mdi-logout</v-icon>
              </v-avatar>
              <div>
                <span class="d-block text-caption font-weight-medium text-uppercase text--secondary"
                  >Saídas</span
                >
                <span class="text-h5 font-weight-bold orange--text">{{ totalSaidas }}</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Filter Section -->
      <v-card class="elevation-2 rounded-lg mb-6 pa-4" outlined>
        <v-row align="center">
          <v-col cols="12" sm="5" md="4" class="py-1">
            <v-text-field
              v-model="filtroData"
              label="Filtrar por data"
              type="date"
              dense
              outlined
              hide-details
              prepend-inner-icon="mdi-calendar"
            />
          </v-col>

          <v-col cols="12" sm="4" md="4" class="py-1">
            <v-select
              v-model="filtroEvento"
              :items="eventos"
              label="Tipo de evento"
              item-text="text"
              item-value="value"
              dense
              outlined
              hide-details
              clearable
              prepend-inner-icon="mdi-filter-variant"
            />
          </v-col>

          <v-col cols="12" sm="3" md="4" class="d-flex py-1 justify-sm-end">
            <v-btn color="primary" class="mr-2 rounded-lg px-4" depressed @click="buscarPresencas">
              Filtrar
            </v-btn>
            <v-btn text class="rounded-lg text--secondary" @click="limparFiltros"> Limpar </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- List Section (Mobile first & Responsive cards) -->
      <v-row>
        <v-col cols="12">
          <v-card class="elevation-2 rounded-lg" outlined>
            <!-- Timeline Layout (Mobile / Desktop) -->
            <v-card-text class="pa-0">
              <v-fade-transition group hide-on-leave>
                <div
                  v-for="(presenca, index) in presencas"
                  :key="presenca.id"
                  class="px-4 py-3 border-bottom d-flex align-center justify-between"
                  :class="index % 2 === 0 ? 'bg-light' : ''"
                >
                  <div class="d-flex align-center">
                    <v-avatar
                      :color="presenca.evento === 0 ? 'green lighten-5' : 'orange lighten-5'"
                      size="40"
                      class="mr-3"
                    >
                      <v-icon :color="presenca.evento === 0 ? 'green' : 'orange'" size="20">
                        {{ presenca.evento === 0 ? "mdi-login" : "mdi-logout" }}
                      </v-icon>
                    </v-avatar>
                    <div>
                      <span class="d-block font-weight-bold text-subtitle-1">
                        {{ presenca.evento === 0 ? "Entrada" : "Saída" }}
                      </span>
                      <span class="text-caption text--secondary d-sm-inline d-block">
                        ID: #{{ presenca.id }}
                      </span>
                    </div>
                  </div>

                  <div class="text-right ml-auto">
                    <span class="d-block font-weight-bold primary--text">
                      {{ formatTime(presenca.data_evento) }}
                    </span>
                    <span class="text-caption text--secondary">
                      {{ formatDate(presenca.data_evento) }}
                    </span>
                  </div>
                </div>
              </v-fade-transition>

              <!-- Empty State -->
              <div v-if="presencas.length === 0" class="text-center py-10 px-4">
                <v-avatar color="blue-grey lighten-5" size="80" class="mb-4">
                  <v-icon color="blue-grey lighten-2" size="40"
                    >mdi-clipboard-text-off-outline</v-icon
                  >
                </v-avatar>
                <h3 class="text-h6 font-weight-medium text--primary mb-1">
                  Nenhum registro encontrado
                </h3>
                <p class="text-body-2 text--secondary max-width-300 mx-auto">
                  Não encontramos registros de frequência com os filtros selecionados.
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </main-template>
</template>

<script>
export default {
  name: "PresencasPage",
  props: {
    matricula_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      presencas: [],
      filtroData: null,
      filtroEvento: null,
      eventos: [
        { text: "Entrada", value: 0 },
        { text: "Saída", value: 1 },
      ],
    };
  },
  computed: {
    totalEntradas() {
      return this.presencas.filter((p) => p.evento === 0).length;
    },
    totalSaidas() {
      return this.presencas.filter((p) => p.evento === 1).length;
    },
  },
  mounted() {
    this.buscarPresencas();
  },
  methods: {
    async buscarPresencas() {
      try {
        this.$loaderService.open("Carregando presenças...");

        const params = { matricula_id: this.matricula_id };
        if (this.filtroData) params.data = this.filtroData;
        if (this.filtroEvento !== null && this.filtroEvento !== undefined) {
          params.evento = this.filtroEvento;
        }

        const response = await this.$services.presencasService.getPresencasHikvision(params);
        this.presencas = response.presencas || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    limparFiltros() {
      this.filtroData = null;
      this.filtroEvento = null;
      this.buscarPresencas();
    },
    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";

      // Formata em fuso local sem deslocamento indesejado
      const dia = String(date.getDate()).padStart(2, "0");
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      const ano = date.getFullYear();
      return `${dia}/${mes}/${ano}`;
    },
    formatTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";

      const hora = String(date.getHours()).padStart(2, "0");
      const minuto = String(date.getMinutes()).padStart(2, "0");
      const segundo = String(date.getSeconds()).padStart(2, "0");
      return `${hora}:${minuto}:${segundo}`;
    },
  },
};
</script>

<style scoped>
.border-left-success {
  border-left: 4px solid #4caf50 !important;
}
.border-left-warning {
  border-left: 4px solid #fb8c00 !important;
}
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.border-bottom:last-child {
  border-bottom: none;
}
.bg-light {
  background-color: #fafafa;
}
.bg-white {
  background-color: #ffffff !important;
}
.max-width-300 {
  max-width: 300px;
}
.justify-between {
  justify-content: space-between;
}
</style>
